"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeZone = void 0;
exports.GetLocalDate = GetLocalDate;
exports.GetLocalTime = GetLocalTime;
exports.GetOffsetMins = GetOffsetMins;
exports.DateTimeInTimeZone = DateTimeInTimeZone;
exports.DateToTimezone = DateToTimezone;
exports.createDateInTimeZone = createDateInTimeZone;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const sprintf_js_1 = require("sprintf-js");
const luxon_1 = require("luxon");
var TimeZone;
(function (TimeZone) {
    TimeZone["EST"] = "America/New_York";
    TimeZone["PST"] = "America/Los_Angeles";
    TimeZone["CHUNG"] = "Asia/Chungking";
})(TimeZone || (exports.TimeZone = TimeZone = {}));
function GetLocalDate(time_zone) {
    const date_str = new Date().toLocaleDateString("en-US", {
        timeZone: time_zone,
    });
    const [mm_str, dd_str, yy_str] = date_str.split("/");
    return {
        month: parseInt(mm_str, 10),
        day: parseInt(dd_str, 10),
        year: parseInt(yy_str, 10),
    };
}
function GetLocalTime(date, time_zone) {
    const str = date.toLocaleTimeString("en-US", {
        timeZone: time_zone,
        hour12: false,
    });
    const [hrs, min, sec] = str.split(":");
    return {
        hour: parseInt(hrs, 10),
        minute: parseInt(min, 10),
        second: parseInt(sec, 10),
    };
}
function GetOffsetMins(time_zone) {
    const utc_date_string = new Date().toISOString().split("T")[0];
    const iso_re = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d([+\-])(\d\d):\d\d$/;
    const local_str = (0, moment_timezone_1.default)((0, sprintf_js_1.sprintf)("%sT12:00:00Z", utc_date_string)).tz(time_zone).format();
    const match = local_str.match(iso_re);
    if (!match) {
        throw new Error("Can't parse " + local_str);
    }
    let hrs = parseInt(match[2], 10);
    if (match[1] === "-") {
        hrs *= -1;
    }
    return hrs * 60;
}
/**
 * Create a Date from datetime and timezone.
 */
function DateTimeInTimeZone(date, time_zone) {
    const dateTimeInEST = luxon_1.DateTime.fromObject(date, { zone: time_zone });
    // Convert to UTC and then to a JavaScript Date
    return dateTimeInEST.toUTC().toJSDate();
}
function DateToTimezone(date, time_zone) {
    const mins = GetOffsetMins(time_zone);
    const msec = date.getTime();
    return new Date(msec + mins * 60 * 1000);
}
function createDateInTimeZone(dateString, timeZone) {
    // Parse the date in the given timezone
    const options = {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    };
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(new Date(dateString));
    // Extract date components
    const dateComponents = {};
    for (const part of parts) {
        if (part.type !== 'literal') {
            dateComponents[part.type] = part.value;
        }
    }
    // Build UTC Date
    const year = parseInt(dateComponents['year'], 10);
    const month = parseInt(dateComponents['month'], 10) - 1; // Months are 0-based in JS
    const day = parseInt(dateComponents['day'], 10);
    const hour = parseInt(dateComponents['hour'], 10);
    const minute = parseInt(dateComponents['minute'], 10);
    const second = parseInt(dateComponents['second'], 10);
    return new Date(Date.UTC(year, month, day, hour, minute, second));
}
